export default __webpack_public_path__ + "static/media/wallet.43ed0936.webp";